import React, { Component } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { withRouter } from "react-router-dom";
import SettingsBasic from "./SettingsBasic";
import SettingsSecurity from "./SettingsSecurity";
import { Route, Switch, Redirect } from "react-router-dom";

class Settings extends Component {
  state = {};
  render() {
    const { history } = this.props;
    return (
      <div
        style={{
          display: "flex",
          height: "100%",
        }}
      >
        <div
          style={{
            borderRight: "1px solid #eff3f4",
          }}
        >
          <h2
            className="heading"
            style={{
              margin: 10,
              paddingBottom: 10,
              textAlign: "center",
              borderBottom: "1px solid #eff3f4",
            }}
          >
            Settings
          </h2>
          <Tabs
            value={history.location.pathname}
            onChange={(event, newValue) => {
              history.push(newValue);
            }}
            variant="fullWidth"
            style={{
              fontFamily: "inherit",
              width: 150,
            }}
            orientation="vertical"
          >
            <Tab
              label="Basic Info"
              value="/settings/basic"
              className="profile-tab"
            />
            <Tab
              label="Security"
              value="/settings/security"
              className="profile-tab"
            />
          </Tabs>
        </div>
        <div className="content" style={{
            width: '100%'
        }}>
          <Switch>
            <Route path="/settings/basic" exact component={SettingsBasic} />
            <Route
              path="/settings/security"
              exact
              component={SettingsSecurity}
            />
            <Redirect from="/" to={`/settings/basic`} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(Settings);
